import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
  name: "localDate"
})
export class LocalDatePipe implements PipeTransform {
  transform(value: string): Date {
    if (!value) {
      return null;
    }

    if (value.indexOf("T") !== -1 && value.charAt(value.length - 1) !== "Z") {
      value += "Z";
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
}
